/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dialog_Drop_HereInputs */

const en_dialog_drop_here = /** @type {(inputs: Dialog_Drop_HereInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Drop documents here`)
};

const es_dialog_drop_here = /** @type {(inputs: Dialog_Drop_HereInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Suelta los documentos aquí`)
};

/**
* | output |
* | --- |
* | "Drop documents here" |
*
* @param {Dialog_Drop_HereInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const dialog_drop_here = /** @type {((inputs?: Dialog_Drop_HereInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dialog_Drop_HereInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_dialog_drop_here(inputs)
	return en_dialog_drop_here(inputs)
});